import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../../header';

export const DashboardPage = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <section className="min-h-screen bg-white">
      <Header fixed={false} />

      <div className="flex justify-between items-center p-8">
        <h1 className="text-3xl font-bold">Панель управления</h1>
        <button
          onClick={handleLogout}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Выйти из аккаунта
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-8">
        <div
          className="bg-white shadow-md p-6 rounded-lg cursor-pointer hover:shadow-lg transition"
          onClick={() => navigate('/dashboard/create-product')}
        >
          <h2 className="text-xl font-semibold">Создать новый товар</h2>
          <p className="text-gray-600 mt-2">Добавление товара в БД</p>
        </div>

        <div
          className="bg-white shadow-md p-6 rounded-lg cursor-pointer hover:shadow-lg transition"
          onClick={() => navigate('/dashboard/products')}
        >
          <h2 className="text-xl font-semibold">Управление товарами</h2>
          <p className="text-gray-600 mt-2">Просмотр, редактирование и удаление товаров</p>
        </div>

        <div
          className="bg-white shadow-md p-6 rounded-lg cursor-pointer hover:shadow-lg transition"
          onClick={() => navigate('/dashboard/tags')}
        >
          <h2 className="text-xl font-semibold">Управление тэгами товаров</h2>
          <p className="text-gray-600 mt-2">Классные тэги, блин</p>
        </div>
        <div
          className="bg-white shadow-md p-6 rounded-lg cursor-pointer hover:shadow-lg transition"
          onClick={() => navigate('/dashboard/orders')}
        >
          <h2 className="text-xl font-semibold">Заказы</h2>
          <p className="text-gray-600 mt-2">Просмотр заказов</p>
        </div>
        <div
          className="bg-white shadow-md p-6 rounded-lg cursor-pointer hover:shadow-lg transition"
          onClick={() => navigate('/dashboard/coupons')}
        >
          <div className='flex flex-row space-x-3'>
            <h2 className="text-xl font-semibold">Управление скидками</h2>
            <div className='rounded-xl flex justify-center items-center bg-red-600 px-3 text-white'>
              Новое
            </div>
          </div>
          <p className="text-gray-600 mt-2">Создание, редактирование скидок на весь заказ или на конкретные товары</p>
        </div>

        <div
          className="bg-white shadow-md p-6 rounded-lg cursor-pointer hover:shadow-lg transition"
          onClick={() => navigate('/dashboard/settings')}
        >
          <h2 className="text-xl font-semibold">Настройка сайта</h2>
          <p className="text-gray-600 mt-2">Изменение блоков разных страниц</p>
        </div>
      </div>
    </section>
  );
};
